import { useMemo } from 'react'

import { MapPoint, WorldMap } from '../../WorldMap'

export interface AssetMapProps {
  readonly latitude: number
  readonly longitude: number
}

export default function AssetMap({ latitude, longitude }: Readonly<AssetMapProps>) {
  const points = useMemo<MapPoint[]>(
    () => [
      {
        coordinates: [longitude, latitude],
        properties: {
          id: 'asset-location',
          title: 'Asset Location',
          isActive: true,
        },
      },
    ],
    [latitude, longitude],
  )

  const mapOptions = useMemo(
    () => ({
      center: [longitude, latitude] as [number, number],
      zoom: 14,
      interactive: false,
      dragPanInteraction: false,
      dragRotateInteraction: false,
      scrollZoomInteraction: false,
      dblClickZoomInteraction: false,
      boxZoomInteraction: false,
      keyboardInteraction: false,
      touchInteraction: false,
      touchRotate: false,
    }),
    [latitude, longitude],
  )

  return (
    <div className="cop-asset-details__map">
      <WorldMap
        id="cop-asset-details-map"
        points={points}
        autoCenter={false}
        options={mapOptions}
      />
    </div>
  )
}
